import React from 'react';
import clsx from 'clsx';
import { buildRowActionsRendererDefinition, getColumnsToRender } from 'hooks/datatable';
import { rowClickBuilder } from 'hooks/profileActions';
import DataTable from 'UI/components/organisms/DataTable';
import { SendoutsTypes } from 'UI/constants/status';
import { useDataTableStyles } from 'UI/globalStyles/DataTableStyles';

import { DUPLICATES_TABLE_COLUMNS } from './DuplicatesTable.constants';

export const DuplicatesTable = ({
  data,
  onOpenSendoutDetails = () => {},
  onOpenSendoverDetails = () => {}
}) => {
  const dataTableClasses = useDataTableStyles();

  const handleViewClick = item => {
    if (!item) return;

    if (item.type?.id === SendoutsTypes.Sendout) onOpenSendoutDetails({ sendoutId: item.id });
    else if (item.type?.id === SendoutsTypes.Sendover)
      onOpenSendoverDetails({ sendoverId: item.id });
  };

  const actionButton = buildRowActionsRendererDefinition({
    actions: [
      {
        name: 'view',
        onClick: rowClickBuilder({
          columns: DUPLICATES_TABLE_COLUMNS,
          data,
          pickId: false,
          callback: handleViewClick
        })
      }
    ]
  });

  const finalColumns = getColumnsToRender([...DUPLICATES_TABLE_COLUMNS, actionButton]);
  return (
    <DataTable
      columns={finalColumns}
      data={data}
      sort
      isServerSide={false}
      filter={false}
      search={false}
      elevation={0}
      pagination={false}
      selectableRowsHeader={false}
      selectableRows="none"
      CustomToolbar={<></>}
      className={clsx(dataTableClasses.withoutToolbar)}
    />
  );
};
